module.exports = __webpack_public_path__ + "static/media/res.9646abb9.webp";